import { createListenerMiddleware, ListenerEffectAPI, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { AppState } from 'common/models/AppState';

const listenerMiddleware = createListenerMiddleware<AppState>();

export type AppListenerEffectApi = ListenerEffectAPI<AppState, ThunkDispatch<AppState, unknown, UnknownAction>>;

export const startListening = listenerMiddleware.startListening;
export const middleware = listenerMiddleware.middleware;
